import toastr from "toastr";

const showToastBar = (title,message) => { 
       
    toastr.options = {
        "toastClass": "toastvvv toast-bootstrap",
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut" 
      }
     if(title === 'Success'){ 
        toastr.success(message, title);
     }
     if(title === 'Error'){
      toastr.error(message, title); 
     }
  }

  export default showToastBar;